module.exports = __webpack_public_path__ + "img/Psychea_Logo_White.281d583f.png";